
import Inventory from "@/state/Inventory";
import { Item } from "@/types";
import { defineComponent } from "vue";
import ExplosionOverlay from "../overlays/ExplosionOverlay.vue";

export default defineComponent({
  components: { ExplosionOverlay },
  props: {
    lastRoll: {
      type: Object as () => Item[],
      required: true,
    },
    inventory: {
      type: Object as () => Inventory,
      required: true,
    },
  },
  emits: ["exit", "reveal-all"],
  data() {
    return {
      currentIndex: 0,
      animationIndex: -2,
    };
  },
  computed: {
    currentItem(): Item {
      return this.lastRoll[this.currentIndex];
    },
    currentItemImage(): string {
      const images = require.context(
        "@/assets/images/drops/",
        false,
        /\.webp$/
      );
      try {
        return images(`./${this.currentItem.id}.webp`);
      } catch (error) {
        return `${this.currentItem.id}.webp`;
      }
    },
    currentItemAudio(): string {
      const name = `${this.currentItem.rarity}-star-wish-reveal${
        this.currentIndex === 0 ? "-first" : ""
      }`;
      try {
        return require.context(
          "@/assets/audio",
          false,
          /\.mp3$/
        )(`./${name}.mp3`);
      } catch (error) {
        console.error(`Could not find ${name}.mp3.`);
        return "";
      }
    },
  },
  methods: {
    nextItem() {
      this.currentIndex += 1;
      if (this.currentIndex >= this.lastRoll.length) {
        if (this.lastRoll.length === 1) {
          this.exit();
        } else {
          this.$emit("reveal-all");
        }
        return;
      }

      this.animationIndex = -2;
      if (this.currentIndex >= 1) {
        if (
          this.currentItem.rarity ===
            this.lastRoll[this.currentIndex - 1].rarity &&
          this.currentIndex >= 1
        ) {
          // audio depends on rarity and the first two
          // audios are guaranteed to be different because of
          // "first"
          this.animationIndex += 1;
        }

        if (this.currentItem.id === this.lastRoll[this.currentIndex - 1].id) {
          // if the image has already loaded
          this.animationIndex += 1;
        }
      }

      /*
       * Animation index documentation
       * below 0: image and/or sfx have yet to finish loading
       * 0: item image zooms in
       * 1: item image and name text slides in
       * 2+: individual stars load in, extra text slides in
       */
    },
    nextAnimation() {
      this.animationIndex += 1;
    },
    exit() {
      this.$emit("exit");
    },
    playSfx() {
      if (this.animationIndex > 0) {
        // only play sound when assets have loaded
        return;
      }
      const audioRef = (
        this.$refs.audioItemReveal as Array<HTMLAudioElement>
      )[0];
      audioRef.pause();
      audioRef.currentTime = 0;
      audioRef.play();
    },
  },
});
